import translator from '@/common/translate';
import { mapState, mapActions } from 'pinia';
import { usePageStore } from '@/store';
export default {
    computed: {
        ...mapState(usePageStore, {
            currentLanguage: store => store.currentLanguage,
            languageMenus: store => store.languageMenus,
            translatorType: store => store.translatorType
        }),
        translateMenu({ languageMenus }) {
            return {
                items: languageMenus
            };
        },
        showTranslatePlugin({ translatorType }) {
            return !!translatorType;
        },
        currentLanguageItem() {
            let lang = this.languageMenus.find(
                item => item.name == this.currentLanguage
            );
            return (
                lang || {
                    name: this.currentLanguage,
                    label: this.currentLanguage
                }
            );
        }
    },
    methods: {
        ...mapActions(usePageStore, {
            setLanguage: 'setLanguage'
        }),
        selectLanguage(langItem) {
            var lang = langItem.name;
            this.setLanguage(lang).then(({ changed }) => {
                if (changed) {
                    this.showMobileLangMenu = false;
                    translator.setLang(lang);
                }
            });
        }
    }
};
